import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import "./index.css";
import { ArticleProvider } from "./Contexts/ArticleContext";
import { ActiveArticleProvider } from "./Contexts/ActiveArticleContext";
import { PaginatedArticleProvider } from "./Contexts/PaginatedArticleContext";
import { CurrentPageProvider } from "./Contexts/CurrentPageContext";
import { PagesProvider } from "./Contexts/PagesContext";

ReactDOM.render(
  <PagesProvider>
    <CurrentPageProvider>
      <PaginatedArticleProvider>
        <ActiveArticleProvider>
          <ArticleProvider>
            <App />
          </ArticleProvider>
        </ActiveArticleProvider>
      </PaginatedArticleProvider>
    </CurrentPageProvider>
  </PagesProvider>,
  document.getElementById("root")
);
